import Cookies from 'js-cookie'
import cookie from '@assets/js/public/Cookie'

const userProfile = 'userProfile'

export function getToken(TokenKey) {
    return cookie.getCookie(TokenKey);
}

export function setToken(TokenKey, token) {
    // cookie.setCookie(TokenKey, token, 30 * 60 * 100);
    return Cookies.set(TokenKey, token, { expires: 2 })
}

export function removeToken(TokenKey) {
    return cookie.removeCookie(TokenKey)
}


export function getCityInfo(cityKey){
    return cookie.getCookie(cityKey)
}
export function setCityInfo(cityKey,cityInfo){
   return  cookie.setCookie(cityKey,cityInfo)
}

export function removeCityInfo(cityKey){
    return cookie.removeCookie(cityKey)
}
